import { useQuery, useMutation } from '@tanstack/react-query';
import { api } from '../services/api';
import type {
  CheckInCategory,
  CheckInStrategyListItem,
  CheckInStrategyDetail,
} from '../types/check-in.types';

// Query key factory
export const checkInKeys = {
  all: ['check-in'] as const,
  categories: () => [...checkInKeys.all, 'categories'] as const,
  strategies: (categoryLabel: string) =>
    [...checkInKeys.all, 'strategies', categoryLabel] as const,
  strategyDetail: (id: string) =>
    [...checkInKeys.all, 'strategy', id] as const,
};

export function useCheckInCategories() {
  return useQuery<CheckInCategory[]>({
    queryKey: checkInKeys.categories(),
    queryFn: () => api.getCheckInCategories(),
  });
}

export function useCheckInStrategies(categoryLabel: string) {
  return useQuery<CheckInStrategyListItem[]>({
    queryKey: checkInKeys.strategies(categoryLabel),
    queryFn: () => api.getCheckInStrategies(categoryLabel),
    enabled: !!categoryLabel,
  });
}

export function useCheckInStrategyDetail(id: string) {
  return useQuery<CheckInStrategyDetail>({
    queryKey: checkInKeys.strategyDetail(id),
    queryFn: () => api.getCheckInStrategyDetail(id),
    enabled: !!id,
  });
}

export function useCompleteStrategy() {
  return useMutation({
    mutationFn: (strategyId: string) => api.completeStrategy(strategyId),
    onSuccess: () => {
      // No cache invalidation needed — completion doesn't affect displayed data
    },
  });
}
